
export const HumanAgent = {
    name: 'Human',
    isMachine: false,
};
